import { AccessDecisionManager } from "@activecollab/security";
import { CompanyVoter } from "~/security/CompanyVoter";
import { InvoiceVoter } from "~/security/InvoiceVoter";
import { NoteVoter } from "~/security/NoteVoter";
import { ProjectVoter } from "~/security/ProjectVoter";
import { TimeRecordVoter } from "~/security/TimeRecordVoter";
import { TimesheetVoter } from "~/security/TimesheetVoter";
import { UserVoter } from "~/security/UserVoter";
import { WorkloadVoter } from "~/security/WorkloadVoter";
import { CalendarEventVoter } from "./CalendarEventVoter";
import { CalendarVoter } from "./CalendarVoter";
import { CommentVoter } from "./CommentVoter";
import { DiscussionVoter } from "./DiscussionVoter";
import { EstimateVoter } from "./EstimateVoter";
import { ExpenseVoter } from "./ExpenseVoter";
import { GhostTaskVoter } from "./GhostTaskVoter";
import { SubtaskVoter } from "./SubtaskVoter";
import { TaskVoter } from "./TaskVoter";
import { TrackingObjectVoter } from "./TrackingObjectVoter";

const projectVoter = new ProjectVoter();
const trackingObjectVoter = new TrackingObjectVoter();
const expenseVoter = new ExpenseVoter();
const timeRecordVoter = new TimeRecordVoter();
const timeSheetVoter = new TimesheetVoter();
const commentVoter = new CommentVoter();
const noteVoter = new NoteVoter();
const discussionVoter = new DiscussionVoter();
const taskVoter = new TaskVoter();
const userVoter = new UserVoter();
const workloadVoter = new WorkloadVoter();
const estimateVoter = new EstimateVoter();
const invoiceVoter = new InvoiceVoter();
const calendarEventVoter = new CalendarEventVoter();
const subtaskVoter = new SubtaskVoter();
const ghostTaskVoter = new GhostTaskVoter();
const companyVoter = new CompanyVoter();
const calendarVoter = new CalendarVoter();

const voters = [
  projectVoter,
  trackingObjectVoter,
  expenseVoter,
  timeRecordVoter,
  timeSheetVoter,
  commentVoter,
  noteVoter,
  discussionVoter,
  taskVoter,
  userVoter,
  workloadVoter,
  estimateVoter,
  invoiceVoter,
  calendarEventVoter,
  subtaskVoter,
  ghostTaskVoter,
  companyVoter,
  calendarVoter,
];

export const allowedArguments = [
  ...new Set([
    ...projectVoter.attributes,
    ...trackingObjectVoter.attributes,
    ...expenseVoter.attributes,
    ...timeRecordVoter.attributes,
    ...timeSheetVoter.attributes,
    ...commentVoter.attributes,
    ...noteVoter.attributes,
    ...discussionVoter.attributes,
    ...taskVoter.attributes,
    ...userVoter.attributes,
    ...workloadVoter.attributes,
    ...estimateVoter.attributes,
    ...invoiceVoter.attributes,
    ...calendarEventVoter.attributes,
    ...subtaskVoter.attributes,
    ...ghostTaskVoter.attributes,
    ...companyVoter.attributes,
    ...calendarVoter.attributes,
  ]),
];

export default new AccessDecisionManager(voters);
